const PRESET_COLORS: Record<string, string> = {
  Abbigliamento: 'bg-pink-500 text-white',
  Tecnologia: 'bg-teal-500 text-white',
  'Arredo casa': 'bg-amber-500 text-white',
  Gioielli: 'bg-purple-500 text-white',
  Sport: 'text-white',
  Accessori: 'bg-slate-500 text-white',
  'Gift Card': 'bg-green-500 text-white',
  Altro: 'bg-orange-500 text-white',
  Varie: 'bg-cyan-500 text-white',
  Skincare: 'text-white',
}

const SKINCARE_COLOR = '#47b182'
const SPORT_COLOR = '#7e97fc'

const FALLBACK_PALETTE = [
  'bg-rose-500 text-white',
  'bg-indigo-500 text-white',
  'bg-cyan-500 text-white',
  'bg-violet-500 text-white',
  'bg-emerald-500 text-white',
  'bg-fuchsia-500 text-white',
  'bg-blue-500 text-white',
  'bg-lime-500 text-white',
  'bg-red-500 text-white',
  'bg-yellow-500 text-white',
]

function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

let customColorsByUser: Record<string, string> = {}
let customColorsKey: string | null = null

export function setCustomCategoryColors(
  userId: string | null | undefined,
  categories: Array<{ name: string; color?: string | null }> | null | undefined
) {
  const key = userId ?? null
  if (key === customColorsKey && !categories) return
  customColorsKey = key ?? null
  const map: Record<string, string> = {}
  for (const c of categories ?? []) {
    if (c.color) map[c.name] = c.color
  }
  customColorsByUser = map
}

function hexToRgba(hex: string, alpha: number): string {
  const clean = hex.replace('#', '')
  const full = clean.length === 3 ? clean.split('').map((ch) => ch + ch).join('') : clean
  const num = parseInt(full, 16)
  const r = (num >> 16) & 255
  const g = (num >> 8) & 255
  const b = num & 255
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function getCategoryColor(category: string): string {
  if (PRESET_COLORS[category]) return PRESET_COLORS[category]
  const idx = hashString(category) % FALLBACK_PALETTE.length
  return FALLBACK_PALETTE[idx]
}

export function getCategoryColorClasses(category: string): string {
  if (category === 'Skincare' || category === 'Sport') return PRESET_COLORS[category]
  return getCategoryColor(category)
}

export function getCategoryInlineStyle(category: string): React.CSSProperties | undefined {
  if (category === 'Skincare') return { backgroundColor: SKINCARE_COLOR }
  if (category === 'Sport') return { backgroundColor: SPORT_COLOR }
  const custom = customColorsByUser[category]
  if (custom) return { backgroundColor: custom, color: '#fff' }
  return undefined
}

export function getCategoryCustomHex(category: string): string | undefined {
  return customColorsByUser[category]
}

export { hexToRgba }

const CATEGORY_TRANSLATIONS: Record<string, string> = {
  'Accessori': 'Accessories',
  'Abbigliamento': 'Clothing',
  'Arredo casa': 'Home decor',
  'Tecnologia': 'Technology',
  'Gioielli': 'Jewelry',
  'Sport': 'Sport',
  'Gift Card': 'Gift Card',
  'Altro': 'Other',
  'Varie': 'Miscellaneous',
  'Skincare': 'Skincare',
}

export function translateCategory(category: string | null | undefined, language: 'it' | 'en' = 'it'): string {
  if (!category) return ''
  if (language === 'en') return CATEGORY_TRANSLATIONS[category] ?? category
  return category
}

export { PRESET_COLORS, FALLBACK_PALETTE, CATEGORY_TRANSLATIONS }
